export default __webpack_public_path__ + "static/media/AccountCalendar.ceb3aa37.svg";